import { render, staticRenderFns } from "./UserDetailButtons.vue?vue&type=template&id=247240ad&scoped=true&"
import script from "./UserDetailButtons.vue?vue&type=script&lang=ts&"
export * from "./UserDetailButtons.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailButtons.vue?vue&type=style&index=0&id=247240ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247240ad",
  null
  
)

export default component.exports